import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import './style.css'
import { EXTRA_DATA } from '../../ModifyNode/config'

const AddtionalInformation = props => {

    const [ value, setValue ] = useState( null );

    /**
     * We format data here to ensure input consistency for formatable data types
     * @name formatValue
     * @function
     * @description Formats the data for display
     */
    const formatValue = useCallback( val => {

        let tempValue;

        // format data if necessary
        switch( EXTRA_DATA[ props.type ][ props.field ] ){
            case 'date':
                const d = new Date( val );
                tempValue = d.toLocaleDateString( props.locale, { dateStyle: 'long' }) + ' @ ' + d.toLocaleTimeString( props.locale, { timeStyle: 'short' });
                break;
            default:
                tempValue = val;
                break;
        }

        setValue( tempValue );

    }, [ setValue, props.type, props.field, props.locale ]);

    // format value when it changes
    useEffect(() => {
        formatValue( props.value );
    }, [ props.value, formatValue ]);

    return (
        
            value?.split( '\n' ).map(
                ( val, index ) => (
                    <tspan className="coe__node__additionalInformation" x="0" dy="1.5em" key={ val + index }>
                        {
                            index === 0 ?
                                `${ props.label }: `:
                                null
                        }
                        { val }
                    </tspan>
                )
            )
        
       
    )
}

AddtionalInformation.propTypes = {
    field: PropTypes.string.isRequired,
    locale: PropTypes.string,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
}

export default AddtionalInformation